<template>

  <div>
    <form @submit.prevent="submitForm" v-if="!formSubmitted">
      <div class="card">
        <div class="card-header">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder fs-3 mb-1 dm-fs-1-1-rem dm-color-3f4254">Mobile Number</span>
          </h3>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <VuePhoneNumberInput
                  v-model="phone"
                  :default-country-code="phone_codes"
                  size="sm"
                  required="required"
                  clearable="clearable"
                  @update="updatePhoneNumber"/>
            </div>
          </div>

        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-md-12">
              <button :disabled="!isValid" type="submit" class="btn btn-primary me-2">Submit
              </button>
              <button v-if="data_.isModal"
                      @click="close"
                      type="button"
                      class="btn btn-light ml-1"
              >
                Skip
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="card" v-if="formSubmitted">
      <form @submit.prevent="submitVerifidForm">
        <div class="card-header">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label fw-bolder fs-3 mb-1 dm-fs-1-1-rem dm-color-3f4254">Phone verified</span>
          </h3>
        </div>
        <div class="card-body">
          <p class="text-success fx-bolder">Your Phone is : {{ formattedNumber }}</p>
          <p class="text-danger">Please check security code on your phone. and Enter your code here...</p>
          <input type="number" v-model="code" value="" placeholder="Enter Your code.."
                 class="form-control form-control-sm form-control-solid mb-3" required>
        </div>
        <div class="card-footer">
          <div class="row">
            <div class="col-md-12">
              <button type="submit" class="btn btn-primary me-2">Verify
              </button>

              <button v-if="data_.isModal"
                      @click="close"
                      type="button"
                      class="btn btn-light ml-1"
              >
                Skip
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

  </div>

</template>

<style scoped>
.vm--modal {
  height: auto !important;
}
</style>

<script>

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
  components: {
    VuePhoneNumberInput,
  },
  props: {
    number: '',
    cn_code: '',
  },
  data() {
    return {
      phone: '',
      formattedNumber: '',
      phoneData: [],
      formSubmitted: false,
      isValid: false,
      code: '',
      phone_codes: 'GB',
      data_: {
        isModal: true,
      }
    };
  },
  mounted() {
    if (this.number) {
      this.phone = this.number
    }
    if (this.cn_code) {
      this.phone_codes = this.cn_code
    }
  },
  methods: {
    updatePhoneNumber(data) {
      console.log(data)
      this.formattedNumber = data.formattedNumber;
      this.phoneData = data;
      this.isValid = data.isValid;
      this.phone_codes = data.countryCode;
    },
    submitForm: function () {

      this.$axios.post(this.genUrl('users', null, 'send_verify_code'), {

        phone: this.formattedNumber

      }).then(({data}) => {
        if (data.success == true) {
          this.formSubmitted = true
        }
        console.log(data)
      }).catch(err => this.toastLaraValidation(err))
    },
    submitVerifidForm: function () {
      console.log(this.code)
      console.log(this.formattedNumber)
      this.$axios.post(this.genUrl('users', null, 'check_verify_code'), {
        params: {
          phone: this.formattedNumber,
          code: this.code,
          phone_codes: this.phone_codes,
        }
      }).then(({data}) => {
        console.log(data)
        if (data.success == true) {
          this.toastSuccess('Success!', "Your Phone is verified");
          this.$root.$emit('phone_updated', {phone: this.formattedNumber, cn_code: this.phone_codes})
          this.close()
          // window.location.href = '/app/dashboard/';
        }else{
          this.toastSuccess('Oops!', "Please provide correct OTP");
        }

      }).catch(err => this.toastLaraValidation(err))
    },
    close() {
      this.$parent.close ? this.$parent.close() : this.$emit('close')
    },


  }
};
</script>
